module.exports = __webpack_public_path__ + "img/9.e92a9f25.jpg";